import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noimages'
})
export class NoimagesPipe implements PipeTransform {

  transform( image: any ): string {

    if ( !image ) {
      return 'assets/img/icono-no-imagen.png';
    }

    if ( image != null ) {
      return image;
    } else {
      return 'assets/img/icono-no-imagen.png';
    }

  }

}
